import request from '@/common/api'
import { HOSTS } from '../utils/env'

export const getBatchList = async (params: {
  pageNo: number;
  pageSize: number;
}) => {
  try {
    const data = await request.get<{ result: any[]; totalCount: number }>(
      `${HOSTS.BASE}/api/entweb/balanceBatch/list`,
      { params }
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

export const createBatch = async (params: { batchName: string }) => {
  try {
    const data = await request.post<any>(
      `${HOSTS.BASE}/api/entweb/balanceBatch/create`,
      { ...params }
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

export const updateBatch = async (params: {
  batchName: string;
  batchNo: string;
}) => {
  try {
    const data = await request.post<any>(
      `${HOSTS.BASE}/api/entweb/balanceBatch/update`,
      { ...params }
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}
